import { useIntl } from '@capsicum/common';
import { BaseCheckboxInput as Checkbox, GenericDrawer } from '@capsicum/common-web';
import { useState } from 'react';
import styled from 'styled-components';

export type ConfirmDeliveryAddressProps = {
	address: string;
	city: string;
	country: string;
	onEdit: () => void;
	onPress: () => void;
	privacyUrl: string;
	testID: string;
	zipCode: string;
};

export const ConfirmDeliveryAddress = ({
	address,
	city,
	country,
	onEdit,
	onPress,
	privacyUrl,
	testID,
	zipCode
}: ConfirmDeliveryAddressProps) => {
	const { $t } = useIntl();
	const [consent, setConsent] = useState<boolean>(false);

	return (
		<S.DrawerContainer
			buttonDisabled={!consent}
			buttonText={$t('rewards.auctions.bids.confirmAddress.confirm')}
			isButtonOnRow={false}
			secondaryActionButtonText={$t('rewards.auctions.bids.confirmAddress.change')}
			testID={testID}
			title={$t('rewards.auctions.bids.confirmAddress.title')}
			onButtonPress={onPress}
			onSecondaryActionOnButtonPress={onEdit}
		>
			<S.TextWrapper>
				<S.StyledShippingTo>{$t('rewards.auctions.bids.confirmAddress.text')}</S.StyledShippingTo>
				<S.StyledAddressData>{address}</S.StyledAddressData>
				<S.StyledAddressData>{`${zipCode} ${city}`}</S.StyledAddressData>
				<S.StyledAddressData>{country}</S.StyledAddressData>
			</S.TextWrapper>
			<S.CheckboxWrapper>
				<Checkbox testID="confirm-delivery-address-consent-checkbox" onChange={checked => setConsent(checked)}>
					<S.CheckBoxContainer>
						{$t<JSX.Element>('rewards.auctions.bids.confirmAddress.privacyPolicy', {
							link: chunks => (
								<S.CheckBoxText
									data-testid="confirm-delivery-address-privacy-policy-link"
									href={privacyUrl}
								>
									{chunks}
								</S.CheckBoxText>
							)
						})}
					</S.CheckBoxContainer>
				</Checkbox>
			</S.CheckboxWrapper>
		</S.DrawerContainer>
	);
};

namespace S {
	export const DrawerContainer = styled(GenericDrawer)`
		margin-top: ${({ theme }) => theme.spacings.large};
	`;

	export const TextWrapper = styled.div`
		margin-top: ${({ theme }) => theme.spacings.xxsmall};
		margin-bottom: ${({ theme }) => theme.spacings.large};
		text-align: center;
	`;

	export const StyledText = styled.p`
		text-align: center;
	`;

	export const StyledShippingTo = styled.div`
		${({ theme }) => theme.fonts.text.text3};
	`;

	export const StyledAddressData = styled.div`
		${({ theme }) => theme.fonts.text.text1};
	`;

	export const CheckboxWrapper = styled.div`
		width: 100%;
		max-width: 400px;
		margin: auto;
	`;

	export const CheckBoxContainer = styled.div`
		${({ theme }) => theme.fonts.text.caption2};
		color: ${({ theme }) => theme.colors.text.main.enabled};
	`;

	export const CheckBoxText = styled.a`
		${({ theme }) => theme.fonts.text.caption2};
		color: ${({ theme }) => theme.colors.text.brand.enabled};
	`;
}
